import React, { useEffect, useState } from "react";
import api from "../../../api/api";
import { CircularProgress } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faDownload } from "@fortawesome/free-solid-svg-icons";

export default function ICard({ activeTab, data }) {
  const practiseid = window.getPracticeId();
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/pcard/${data?.patientid}/getpatientIcard`
      );

      if (response.status === 200) {
        const front = response.data?.ins_photo_front;
        const back = response.data?.ins_photo_back;

        const imgs = [];
        if (front) imgs.push(`data:image/jpeg;base64,${front}`);
        if (back) imgs.push(`data:image/jpeg;base64,${back}`);

        setImages(imgs);
      } else {
        setImages([]);
      }
    } catch (error) {
      console.log(error);
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "icard") {
      fetchData();
    }
  }, [activeTab]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = images[currentIndex];
    link.download = `insurance_card_${currentIndex + 1}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="w-full min-h-[70vh] flex flex-col items-center justify-center pt-20 bg-white rounded-md shadow-[0_-4px_12px_rgba(0,0,0,0.1)]">
      {loading ? (
        <CircularProgress />
      ) : images.length === 0 ? (
        <div className="py-2 w-[284px] rounded-lg border-[1px] border-[#1447E6] bg-[#1447E61A] text-[#1447E6] text-[16px] font-light font-inter text-center">
          No data found
        </div>
      ) : (
        <div className="flex flex-col items-center space-y-4">
          <div className="flex items-center space-x-4">
            <FontAwesomeIcon
              icon={faChevronLeft}
              size="2x"
              className="cursor-pointer text-blue-600"
              onClick={handlePrev}
            />

            <img
              src={images[currentIndex]}
              alt={`Insurance Card ${currentIndex + 1}`}
              className="w-[300px] h-auto rounded-lg shadow-md"
            />

            <FontAwesomeIcon
              icon={faChevronRight}
              size="2x"
              className="cursor-pointer text-blue-600"
              onClick={handleNext}
            />
          </div>

          <button
            onClick={handleDownload}
            className="px-4 py-2 bg-green-500 text-white rounded flex items-center space-x-2"
          >
            <FontAwesomeIcon icon={faDownload} />
            <span>Download Image</span>
          </button>

          <p>
            Image {currentIndex + 1} of {images.length}
          </p>
        </div>
      )}
    </div>
  );
}
